import { render, staticRenderFns } from "./ApexChartBar.vue?vue&type=template&id=4b54762f&"
import script from "./ApexChartBar.vue?vue&type=script&lang=js&"
export * from "./ApexChartBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports